import { Box, Typography } from '@mui/material'

import { BookingAddress } from 'generated/graphql'
import { formatTimeSlot } from 'helpers'

import { LocationItem } from './LocationItem'
import { SectionHeader } from './SectionHeader'

interface DropOffSectionProps {
  nextBookingAction?: BookingAddress | null
}

const containerStyles = {
  mb: 4,
  borderBottom: '2px solid #F6F4F4',
  pb: 2,
}

export const DropOffSection = ({ nextBookingAction }: DropOffSectionProps) => {
  if (!nextBookingAction) {
    return (
      <Box sx={containerStyles}>
        <SectionHeader title='DROP-OFF' />
        <Typography variant='body2' color='text.secondary'>
          No drop-off information available
        </Typography>
      </Box>
    )
  }

  const address = nextBookingAction.address

  const locationName = address?.city

  const fullAddress = [
    address?.addressLine1,
    address?.addressLine2,
    address?.city,
    address?.postcode,
  ]
    .filter(Boolean)
    .join(', ')

  const timeSlot = formatTimeSlot(nextBookingAction.at, nextBookingAction.by)

  return (
    <Box sx={containerStyles}>
      <SectionHeader title='DROP-OFF' />
      <Box>
        <LocationItem name={locationName} address={fullAddress} timeSlot={timeSlot} />
      </Box>
    </Box>
  )
}
